module.exports = __webpack_public_path__ + "static/grandmaster-d7868a948948d9bb7d93e2a2d09b83b7.webp";